/**
 * Switch to selected page.
 */
function switch_page_tabs(){

    if(!!document.querySelector('.tabs-support li.tab')){

        let tabsSupport = document.querySelectorAll(".tabs-support li.tab");

        tabsSupport.forEach((tab) => {
            tab.addEventListener("click", () => {
                let goto = tab.dataset.goto;
    
                location.href = goto;
            });
        });
    }
}

switch_page_tabs();

export default switch_page_tabs;